<template>
  <div>
    <JessibucaDemo :url="url" />
    <div class="control">
      <div class="ctrl_line">
        <div class="ctrl_bg">
          <span class="add" @click="handleCtrlClick('zoomin')">
            <img src="./../../../assets/images/plus.png" alt="" />
          </span>
          <span class="jian" @click="handleCtrlClick('zoomout')">
            <img src="./../../../assets/images/jian.png" alt="" />
          </span>
        </div>
      </div>

      <div class="box">
        <div class="arrow lt" @touchstart="handleCtrlClick('upleft')">
          <span class="text">左上</span>
          <span>
            <img src="./../../../assets/images/arrow.png" alt="" />
          </span>
        </div>

        <div class="arrow rt" @click="handleCtrlClick('upright')">
          <span class="text">右上</span>
          <span><img src="./../../../assets/images/arrow.png" alt="" /></span>
        </div>

        <div class="arrow lb" @click="handleCtrlClick('downleft')">
          <span class="text">左下</span>
          <span>
            <img src="./../../../assets/images/arrow.png" alt="" />
          </span>
        </div>

        <div class="arrow rb" @click="handleCtrlClick('downright')">
          <span class="text">右下</span>
          <span><img src="./../../../assets/images/arrow.png" alt="" /></span>
        </div>

        <div class="row top">
          <div class="arrow"></div>
          <div class="arrow t" @click="handleCtrlClick('up')">
            <span class="text">上</span>
            <span><img src="./../../../assets/images/arrow.png" alt="" /></span>
          </div>
          <div class="arrow"></div>
        </div>

        <div class="row middle">
          <div class="arrow l" @click="handleCtrlClick('left')">
            <span class="text">左</span>
            <span>
              <img src="./../../../assets/images/arrow.png" alt="" />
            </span>
          </div>
          <div class="arrow r" @click="handleCtrlClick('right')">
            <span class="text">右</span>
            <span><img src="./../../../assets/images/arrow.png" alt="" /></span>
          </div>
        </div>
        <div class="row bottom">
          <div class="arrow"></div>

          <div class="arrow b" @click="handleCtrlClick('down')">
            <span class="text">下</span>
            <span><img src="./../../../assets/images/arrow.png" alt="" /></span>
          </div>
          <div class="arrow"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- -->
  <!-- <VideoJS v-if="url" :videoUrl="url" /> -->
</template>

<script>
import JessibucaDemo from '@/components/Jessibuca/index.vue'

export default {
  components: { JessibucaDemo },
  props: {
    hasDeviceChange: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    hasDeviceChange(val) {
      this.deviceChange()
    },
  },

  data() {
    return {
      no: localStorage.getItem('no'),
      url: '',
      videoDeviceInfo: null,
    }
  },

  async created() {
    await this.getInfo()
  },

  methods: {
    // 获取摄像头的信息
    async getInfo() {
      await this.$api
        .getVideoDeviceInfo({
          gatewayNo: this.no,
        })
        .then(async (res) => {
          if (res.data.online === 1) {
            await this.getVideoURL(res.data.deviceId)
          }
        })
    },

    // 获取摄像头的直播流地址
    async getVideoURL(id) {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        duration: 0,
      })
      await this.$api
        .getVideoDevicePlayURL({
          deviceId: id,
        })
        .then((res) => {
          this.videoDeviceInfo = { ...res.data.data }

          // this.url = res.data.data.ws_flv
          this.url = res.data.data.wss_flv

          console.log('this.url:', this.url)
          this.$toast.clear()
        })
    },

    deviceChange() {
      this.no = localStorage.getItem('no')
      this.getInfo()
    },

    // 控制器
    async handleCtrlClick(command) {
      await this.$toast.loading({
        message: '数据加载中...',
        duration: 0,
      })
      console.log('this.videoDeviceInfo:', this.videoDeviceInfo)
      const { channelId, deviceID } = this.videoDeviceInfo
      const speed = '30'
      const zero = '0'
      let horizonSpeed = null
      let verticalSpeed = null
      let zoomSpeed = null

      switch (command) {
        case 'left':
        case 'right':
          horizonSpeed = speed
          verticalSpeed = zero
          zoomSpeed = zero
          break
        case 'up':
        case 'down':
          horizonSpeed = zero
          verticalSpeed = speed
          zoomSpeed = zero
          break
        case 'upleft':
        case 'upright':
        case 'downleft':
        case 'downright':
          horizonSpeed = speed
          verticalSpeed = speed
          zoomSpeed = zero
          break
        case 'zoomin':
        case 'zoomout':
          horizonSpeed = zero
          verticalSpeed = zero
          zoomSpeed = speed
          break
        case 'stop':
          horizonSpeed = zero
          verticalSpeed = zero
          zoomSpeed = zero
          break
        default:
          break
      }

      const param = {
        channelId,
        deviceId: deviceID,
        command, //控制指令,允许值: left, right, up, down, upleft, upright, downleft, downright, zoomin（放大）, zoomout（缩小）, stop
        horizonSpeed, // 水平速度 建议默认 30
        verticalSpeed, // 垂直速度 建议默认 30
        zoomSpeed, // 缩放速度 建议默认 30
      }

      await this.$api.ptzControl(param).then((res) => {
        if (res.errcode === 0) {
          //  调用成功后 停止一次
          this.$toast.clear()

          if (command === 'stop') return
          setTimeout(() => {
            this.handleCtrlClick('stop')
          }, 800)
        } else {
          this.$toast.fail(res.errmsg)
        }
      })
    },
  },
}
</script>

<style lang="scss">
.box {
  position: relative;
  width: 200px;
  font-size: 12px;
  margin: auto;
  margin-top: 20px;

  .row {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .arrow {
      position: relative;
    }
  }

  .text {
    position: absolute;
    bottom: 10px;
    left: 6px;
    width: 24px;
    color: #ffffff;
    text-align: center;
    z-index: 100;
  }

  img {
    width: 35px;
    height: 56px;
  }

  .middle {
    display: flex;
    justify-content: space-between;
  }

  .t {
    .text {
      bottom: 10px;
      left: 6px;
    }
  }
  .r {
    img {
      transform: rotate(90deg);
    }
    .text {
      bottom: 20px;
      left: -4px;
    }
  }
  .b {
    img {
      transform: rotate(180deg);
    }
    .text {
      bottom: 28px;
      left: 6px;
    }
  }
  .l {
    img {
      transform: rotate(-90deg);
    }
    .text {
      bottom: 20px;
      left: 16px;
    }
  }
  .lt {
    position: absolute;
    left: 26px;
    top: 20px;
    img {
      transform: rotate(-45deg);
    }
    .text {
      bottom: 13px;
      left: 13px;
    }
  }
  .lb {
    position: absolute;
    left: 26px;
    bottom: 20px;

    img {
      transform: rotate(-135deg);
    }

    .text {
      left: 13px;
      top: 12px;
    }
  }
  .rt {
    position: absolute;
    right: 26px;
    top: 20px;
    img {
      transform: rotate(45deg);
    }
    .text {
      bottom: 13px;
      left: -1px;
    }
  }
  .rb {
    position: absolute;
    right: 26px;
    bottom: 20px;
    img {
      transform: rotate(135deg);
    }

    .text {
      left: -1px;
      top: 13px;
    }
  }
}

.control {
  margin-top: 20px;
}

.ctrl_line {
  .ctrl_bg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 200px;
    height: 40px;
    background: url('./../../../assets/images/ctrl_bg.png') no-repeat 100%;
    background-size: contain;
    margin: auto;
  }

  img {
    width: 20px;
  }

  .add {
    margin-left: 14px;
  }

  .jian {
    margin-right: 14px;
  }
}
</style>
